export enum MemoPosition {
  onTerm,
  onDefinition,
  none,
}
